import { render } from "./ReturnOrder.vue?vue&type=template&id=54be744c&scoped=true"
import script from "./ReturnOrder.vue?vue&type=script&lang=js"
export * from "./ReturnOrder.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=54be744c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54be744c"]])

export default __exports__